/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UndistributeSkillRequestBody = {
  /**
   * The assistant the skill was distributed to.
   */
  assistantId?: string | undefined;
  /**
   * The skill ID.
   */
  id: string;
  /**
   * The plugin the skill was distributed to.
   */
  pluginId?: string | undefined;
};

/** @internal */
export type UndistributeSkillRequestBody$Outbound = {
  assistant_id?: string | undefined;
  id: string;
  plugin_id?: string | undefined;
};

/** @internal */
export const UndistributeSkillRequestBody$outboundSchema: z.ZodMiniType<
  UndistributeSkillRequestBody$Outbound,
  UndistributeSkillRequestBody
> = z.pipe(
  z.object({
    assistantId: z.optional(z.string()),
    id: z.string(),
    pluginId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      assistantId: "assistant_id",
      pluginId: "plugin_id",
    });
  }),
);

export function undistributeSkillRequestBodyToJSON(
  undistributeSkillRequestBody: UndistributeSkillRequestBody,
): string {
  return JSON.stringify(
    UndistributeSkillRequestBody$outboundSchema.parse(
      undistributeSkillRequestBody,
    ),
  );
}
